import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type ReportTab = 'users' | 'claims' | 'tickets' | 'auditlogs';

export interface ReportDownloadParams {
  [key: string]: string | number | boolean | undefined | null;
  search?: string;
  department_name?: string;
  ticket_status?: string;
  module?: string;
  from_date?: string;
  to_date?: string;
}

const endpointByTab: Record<ReportTab, string> = {
  users: API_ENDPOINTS.reports.users,
  claims: API_ENDPOINTS.reports.claims,
  tickets: API_ENDPOINTS.reports.tickets,
  auditlogs: API_ENDPOINTS.reports.auditLogs,
};

export const downloadReportExcel = async (
  tab: ReportTab,
  params?: ReportDownloadParams
): Promise<Blob> => {
  return api.download(endpointByTab[tab], { params });
};
